import {Component, Input} from '@angular/core'

@Component({
  selector: 'dmmp-website-detail-campus-info',
  templateUrl: './website-detail-campus-info.component.html'
})
export class WebsiteDetailCampusInfoComponent {
  @Input() identifier
  @Input() module
  @Input() detailLayout
  @Input() city = 'Ciudad:'
  @Input() telephone = 'Tel:'
  @Input() street = 'Dirección:'
}
